import Stompe from "../../doors/stompe";
import { ConfigurationProps } from "../../Door";

interface SingleStompeProps extends ConfigurationProps {}

const SingleStompe = ({
  materials,
  position,
  scale,
  doorSettings,
}: SingleStompeProps) => {
  return (
    <group scale={scale}>
      <Stompe
        materials={materials}
        position={position}
        kozijnSettings={doorSettings?.main?.kozijnSettings}
      />
    </group>
  );
};
export default SingleStompe;
